<template>
	<div class="prog_reg-body theme-light">
		<div v-if="sellablePrograms.length > 1" class="container">
			<product-selector
				:sellable-programs="sellablePrograms"
				:product="product"
				:form-data="formData"
			/>
		</div>
		<div v-if="!formData.disable_step_4" class="container">
			<div class="row">
				<div class="col-12 col-md-12 mb-4">
					<div
						class="disclaimer alert theme-darkgray mb-2 text-center d-flex align-self-center"
					>
						<span class="alert-circle d-flex align-self-start mr-1">
							Необходим определённый список документов!</span>
						<button
							class="btn btn-link p-0"
							@click.prevent="$bvModal.show('documents-list')"
						>
							Посмотреть
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- <div
			v-if="$auth.loggedIn && $auth.user.is_student === 1"
			class="container"
		>
			<div class="row">
				<div class="col-12 col-md-12 mb-3">
					<div class="small alert alert-success recognition-message">
						Поздравляем, проверка пройдена. Ваша покупка зафиксируется в личном кабинете
					</div>
				</div>
			</div>
		</div> -->

		<div class="person-choise programm_price">
			<div class="container">
				<div class="row">
					<div
						:class="{
							'col-12 col-md-6 mb-4': cardsNumber === 2,
							'col-12 col-lg-6 mb-4': cardsNumber === 1,
						}"
					>
						<div class="card person-card private private_person">
							<div class="row justify-content-center h-100">
								<div
									class="col-11 col-sm-8 col-md-10 col-lg-9 d-flex flex-column justify-content-between align-items-center"
								>
									<div class="w-100 mb-4">
										<div class="card-icon icon-private" />
										<div class="title">
											Стандартная цена
										</div>
										<div class="price-box w-100">
											<div
												v-if="
													!isActiveDiscount &&
														!isActivePromocode
												"
												:class="[
													priceData.currency === 1
														? 'price'
														: '',
													priceData.currency === 2
														? 'usd-price'
														: '',
													priceData.currency === 3
														? 'eur-price'
														: '',
													priceData.currency === 4
														? 'cny-price'
														: '',
												]"
											>
												{{ priceData.price }}
											</div>
											<div
												v-if="
													isActiveDiscount &&
														!isActivePromocode
												"
											>
												<div
													class=""
													:class="[
														priceData.currency === 1
															? 'old-price'
															: '',
														priceData.currency === 2
															? 'old-usd-price'
															: '',
														priceData.currency === 3
															? 'old-eur-price'
															: '',
														priceData.currency === 4
															? 'old-cny-price'
															: '',
													]"
												>
													{{ priceData.price }}
												</div>
												<div
													:class="[
														priceData.currency === 1
															? 'price'
															: '',
														priceData.currency === 2
															? 'usd-price'
															: '',
														priceData.currency === 3
															? 'eur-price'
															: '',
														priceData.currency === 4
															? 'cny-price'
															: '',
													]"
												>
													{{
														priceData.individualPrice
													}}
												</div>
												<div
													class="price-discount-till"
												>
													{{ $t("offerEnds") }}
													{{
														product.active_to
															| moment("DD MMMM")
													}}
												</div>
											</div>
											<div v-if="isActivePromocode">
												<div
													class=""
													:class="[
														priceData.currency === 1
															? 'old-price'
															: '',
														priceData.currency === 2
															? 'old-usd-price'
															: '',
														priceData.currency === 3
															? 'old-eur-price'
															: '',
														priceData.currency === 4
															? 'old-cny-price'
															: '',
													]"
												>
													{{ priceData.basePrice }}
												</div>
												<div
													:class="[
														priceData.currency === 1
															? 'price'
															: '',
														priceData.currency === 2
															? 'usd-price'
															: '',
														priceData.currency === 3
															? 'eur-price'
															: '',
														priceData.currency === 4
															? 'cny-price'
															: '',
													]"
												>
													{{
														priceData.individualPriceWithDiscount ===
															priceData.individualPrice
															? priceData.price
															: priceData.individualPriceWithDiscount
													}}
												</div>
												<div
													v-if="
														isActiveDiscount &&
															priceData.individualPriceWithDiscount !==
															priceData.individualPrice
													"
													class="price-discount-till"
												>
													{{ $t("offerEnds") }}
													{{
														product.active_to
															| moment("DD MMMM")
													}}
												</div>
											</div>
										</div>
										<div class="content-box small">
											<div class="content" />
										</div>
									</div>
									<button
										class="btn btn-primary"
										@click.prevent="setScenario(1)"
									>
										Далее
									</button>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="isAlumni && individualPrice"
						:class="{
							'col-12 col-md-6 mb-4': cardsNumber === 2,
							'col-12 col-lg-6 mb-4': cardsNumber === 1,
						}"
					>
						<div
							class="card person-card group alumni_person"
							style="display: flex !important"
						>
							<div class="row justify-content-center h-100">
								<div
									class="col-11 col-sm-8 col-md-10 col-lg-9 d-flex flex-column justify-content-between align-items-center"
								>
									<div class="w-100">
										<div class="card-icon icon-group" />
										<div class="title">
											Цена для Alumni
										</div>
										<div class="price-box w-100 mb-4">
											<div
												v-if="
													priceData.studentIndividualPrice ===
														priceData.studentIndividualPriceWithDiscount
												"
												:class="[
													priceData.currency === 1
														? 'price'
														: '',
													priceData.currency === 2
														? 'usd-price'
														: '',
													priceData.currency === 3
														? 'eur-price'
														: '',
													priceData.currency === 4
														? 'cny-price'
														: '',
												]"
											>
												{{
													priceData.studentIndividualPrice
												}}
											</div>
											<div
												v-if="
													priceData.studentIndividualPrice !==
														priceData.studentIndividualPriceWithDiscount
												"
												:class="[
													priceData.currency === 1
														? 'old-price'
														: '',
													priceData.currency === 2
														? 'old-usd-price'
														: '',
													priceData.currency === 3
														? 'old-eur-price'
														: '',
													priceData.currency === 4
														? 'old-cny-price'
														: '',
												]"
											>
												{{
													priceData.studentIndividualPrice
												}}
											</div>
											<div
												v-if="
													priceData.studentIndividualPrice !==
														priceData.studentIndividualPriceWithDiscount
												"
												:class="[
													priceData.currency === 1
														? 'price'
														: '',
													priceData.currency === 2
														? 'usd-price'
														: '',
													priceData.currency === 3
														? 'eur-price'
														: '',
													priceData.currency === 4
														? 'cny-price'
														: '',
												]"
											>
												{{
													priceData.studentIndividualPriceWithDiscount
												}}
											</div>
										</div>
										<div class="content-box small">
											<div class="content" />
										</div>
									</div>
									<button
										class="btn btn-primary"
										@click.prevent="handleAlumniClick"
									>
										Далее
									</button>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="sellableProgramIds?.length"
						class="col-12 col-lg-4 column_info"
					>
						<LoyaltyFormBlock
							:products="block.content.products"
							:fetched-data="fetchedData"
							:selected-products="sellableProgramIds"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="row">
				<div class="col-12 col-md-12 mb-4">
					<div class="disclaimer">
						Если вы раньше регистрировались в СКОЛКОВО и готовы
						верифицировать свой личный кабинет, данная покупка будет
						учтена для расчета персональной бонусной программы.
					</div>
				</div>
			</div>
		</div>

		<b-modal id="documents-list" size="lg">
			<div class="d-block">
				<p>
					2.2.1. Для приема (зачисления) на обучение в Школу,
					зачисления на Программу и формирования личного дела
					Слушателя в соответствии с требованиями законодательства
					Российской Федерации Слушатель предоставляет Школе следующие
					документы:
				</p>
				<p>
					- заявление о приеме на программу (электронная регистрация
					на Сайте); - документ, удостоверяющий личность (скан-,
					фотокопия разворота с ФИО); - документ о среднем
					профессиональном или высшем образовании (скан-, фотокопия)
					или документ, выданный в иностранном государстве и
					признаваемый эквивалентным российскому документу о среднем
					профессиональном или высшем образовании на основании
					международного соглашения Российской Федерации с
					государством, в котором выдан такой документ (ранее и далее
					документ об образовании); при получении Слушателем высшего
					или среднего профессионального образования на момент
					зачисления на Программу - - справка из учебного заведения,
					подтверждающая получение Слушателем высшего или среднего
					профессионального образования на момент зачисления на
					Программу (копия). Копия документа об образовании
					предоставляется Слушателем Школы по факту его получения; -
					документ, подтверждающий смену фамилии (при необходимости).
				</p>
				<p>
					2.2.2. Отсутствие документов, указанных в пункте 2.2.1.,
					после начала Программы является основанием для расторжения
					Договора Школой в одностороннем внесудебном порядке. При
					этом в соответствии с Федеральным законом «Об образовании в
					Российской Федерации» удостоверение о повышении квалификации
					или диплом о профессиональной переподготовке не выдаётся, по
					запросу Слушателя ему может быть выдана справка об обучении
					или периоде обучения с указанием количества прослушанных
					часов.
				</p>
			</div>
			<template #modal-footer="{ ok }">
				<b-button
					size="sm"
					class="rounded-pill"
					variant="primary"
					@click="ok()"
				>
					Закрыть
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import {
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_META_DATA,
	ACTION_SET_STEP_AND_SYNC_FORM,
	MUTATION_SET_VALIDATION_META,
	ACTION_SAVE_FORM_DATA_BACKEND,
} from '@/store/checkout';
import checkoutFormStep from '@/mixins/checkoutFormStep';
import { mapActions, mapGetters } from 'vuex';
import moment from '@/utils/moment';
import checkoutForm from '@/mixins/checkoutForm';
import ProductSelector from '@/components/checkout/ProductSelector.vue';
import LoyaltyFormBlock from '~/components/loyalty/LoyaltyFormBlock.vue';

const CURRENT_STEP = 1;

export default {
	name: 'CheckoutStep1',
	components: {
		LoyaltyFormBlock,
		ProductSelector,
	},
	mixins: [checkoutFormStep, checkoutForm],
	props: {
		sellablePrograms: {
			type: Array,
			default: null,
		},
		product: {
			type: Object,
			default: null,
		},
		formData: {
			type: Object,
			default: null,
		},
		sellableProgramIds: {
			type: Array,
			default: () => ([]),
		},
		block: {
			type: Object,
			default: null,
		},
		fetchedData: {
			type: Object,
			default: null,
		},
	},
	computed: {
		...mapGetters({
			getIsStudent: 'checkout/getIsStudent',
			isAlumni: 'profile/isAlumni',
		}),
		cardsNumber() {
			let number = 1;
			if (this.isAlumni) {
				number = 2;
			}
			return number;
		},
		isActiveDiscount() {
			const dateNow = moment().endOf('day');
			if (
				!moment(dateNow).isSameOrBefore(this.product.active_to, 'day')
			) {
				return false;
			}
			if (
				!moment(dateNow).isSameOrAfter(this.product.active_from, 'day')
			) {
				return false;
			}
			return true;
		},
		isActivePromocode() {
			return !!this.priceData.promocode;
		},
		individualPrice() {
			return (
				this.priceData.studentIndividualPrice
				|| this.priceData.studentIndividualPriceWithDiscount
			);
		},
	},
	mounted() {
		/* global yaCounter994527 */
		const clientID =			typeof yaCounter994527 !== 'undefined'
			? yaCounter994527.getClientID()
			: '';
		const { UAClientID } = window;
		const bpmRef = this.$cookies.get('bpmRef') || '';
		const bpmHref = this.$cookies.get('bpmHref') || '';
		const roistatVisitId = this.$cookies.get('roistat_visit') || '';
		const meta = {
			...{
				skGaClientId:
					typeof UAClientID !== 'undefined' ? UAClientID : '',
				skYmClientId: typeof clientID !== 'undefined' ? clientID : '',
				roistatVisitId:
					typeof roistatVisitId !== 'undefined' ? roistatVisitId : '',
				bpmRef,
				bpmHref,
			},
		};
		this.$store.commit(
			`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
			{
				meta,
				formId: this.formData.id,
			},
		);
		this.$store.dispatch(
			`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
			{
				formId: this.formData.id,
			},
		);

		this.$store.dispatch('profile/getRoles');
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
			showRegistrationPopup: 'authModal/showRegistration',
		}),
		handleAlumniClick() {
			if (!this.$auth.loggedIn) {
				this.showLoginPopup();
				return;
			}

			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: {
						isStudent: true,
						scenario: 1,
					},
					formId: this.formData.id,
				},
			);

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{
					formId: this.formData.id,
				},
			);

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SET_STEP_AND_SYNC_FORM}`,
				{
					step: 2,
					formId: this.formData.id,
				},
			);
		},
		setScenario(scenario) {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_VALIDATION_META}`,
				{
					formId: this.formData.id,
					step: CURRENT_STEP,
					isValidate: true,
				},
			);
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: {
						isStudent: false,
						scenario,
					},
					formId: this.formData.id,
				},
			);
			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SET_STEP_AND_SYNC_FORM}`,
				{
					step: 2,
					formId: this.formData.id,
				},
			);
		},
		checkValidation() {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_VALIDATION_META}`,
				{
					formId: this.formData.id,
					step: CURRENT_STEP,
					isValidate: true,
				},
			);

			return true;
		},
		setIsStudent(value) {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: {
						isStudent: value,
					},
					formId: this.formData.id,
				},
			);
			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{
					formId: this.formData.id,
				},
			);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-checkout";
@import "~/assets/styles/components/dev/prog-price";
@import "assets/styles/sk_variables";

.line-through {
	text-decoration: line-through;
}

.loyalty-block {
	color: $body-color;
}
</style>
